import { NotificationBase } from "../types/notification.types";
import { NotificationTaskNotificationFactory } from "./task-notification/TaskNotificationFactory";
import { NotificationTranslatedStringFactory } from "./translated-strings/NotificationTranslatedStringFactory";

interface NotificationItemProps {
  notification: NotificationBase;
  onClick: (notificationId: string) => void;
}
export const NotificationItem = ({
  notification,
  onClick,
}: NotificationItemProps) => {
  const { read, createdAt, id, content, contentType } = notification;
  const extraProps = {
    read,
    createdAt,
    onClick: () => onClick(id),
  };
  const props = { ...extraProps, content };
  switch (contentType) {
    case "translated-strings":
      return (
        <NotificationTranslatedStringFactory {...{ extraProps, content }} />
      );
    case "task-notification":
      return <NotificationTaskNotificationFactory {...props} />;
    default:
      return null;
  }
};
